import React from 'react';
import { CapabilityGate, capabilities } from '../../Services';
import { MADCAP_ARTICLES } from '../../tools/madcapFlare/constant';

/**
 * Promotional content warning message.
 */
const promotionalContentNote =
  'Please ensure not to include any marketing or promotional content or links in these emails to avoid these being classed as marketing emails which could result in these not being delivered and/or adversely affect your email domain.';

/**
 * Email Notifications details text, used in 2 different note types.
 */
const ReadMoreText = () => (
  <span>
    Should you exceed this amount, we may suspend sending emails and/or ask you to purchase a subscription add-on to
    increase the number of emails you can send. You can read more about this on the{' '}
    <a href="#" onClick={() => loadMadCapFlare(MADCAP_ARTICLES.SENDING_EMAILS_FAIR_USAGE_ADD_ONS)}>
      knowledgebase
    </a>
    .
  </span>
);

/**
 * Simple component to display the different notes depending on the EMAIL_NOTIFICATIONS capability
 */
const EmailNotificationsNotes = () => (
  <div className="campaign-customise-notes">
    <Choose>
      <When condition={CapabilityGate(capabilities.EMAIL_NOTIFICATIONS)}>
        <b>
          Notes:
          <ol className="campaign-customise-notes-list">
            <li>
              There is a fair usage limit on the number of emails you can send per month across all of your experiences.{' '}
              <ReadMoreText />
            </li>
            <li>{promotionalContentNote}</li>
          </ol>
        </b>
      </When>
      <Otherwise>
        <b>
          Note that there is a fair usage limit on the number of emails you can send per month across all of your
          experiences. <ReadMoreText />
        </b>
      </Otherwise>
    </Choose>
    <If condition={!CapabilityGate(capabilities.EMAIL_NOTIFICATIONS)}>
      <p className="campaign-customise-notes-nodomain">
        The account needs to have one or more email domain(s) configured for sending these emails. You'll probably
        already have a corporate/brand email domain or{' '}
        <a
          className="inverted text-href"
          href="https://www.forbes.com/advisor/business/how-get-custom-email-domain/"
          target="_blank"
        >
          you can get one
        </a>
        . Once you have it, please contact support to add your email domain(s) in your Grow account.
      </p>
    </If>
  </div>
);

export { promotionalContentNote };
export default EmailNotificationsNotes;
